import type { ThemeConfig } from 'antd';

export const marinaTheme: ThemeConfig = {
  token: {
    colorPrimary: '#5b5bd6',
    colorInfo: '#3b82f6',
    colorSuccess: '#15803d',
    colorWarning: '#b45309',
    colorError: '#c2413a',
    colorText: '#27272a',
    colorTextSecondary: '#71717a',
    colorTextTertiary: '#a1a1aa',
    colorBgBase: '#ffffff',
    colorBgLayout: '#f6f6f8',
    colorBgContainer: '#ffffff',
    colorBorder: '#dedee5',
    colorBorderSecondary: '#ececf0',
    borderRadius: 10,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    controlHeight: 40,
    controlHeightLG: 46,
    controlHeightSM: 34,
    fontFamily:
      'Manrope Variable, Manrope, ui-sans-serif, system-ui, -apple-system, sans-serif',
    fontSize: 14,
    fontSizeHeading1: 32,
    fontSizeHeading2: 26,
    fontSizeHeading3: 20,
    lineHeight: 1.55,
    boxShadow:
      '0 1px 2px rgba(24, 24, 27, 0.04), 0 8px 24px rgba(24, 24, 27, 0.05)',
    boxShadowSecondary:
      '0 14px 40px rgba(24, 24, 27, 0.09), 0 2px 8px rgba(24, 24, 27, 0.05)',
  },
  components: {
    Alert: {
      borderRadiusLG: 14,
      withDescriptionPadding: '16px 18px',
    },
    Button: {
      borderRadius: 10,
      fontWeight: 700,
      primaryShadow: '0 5px 14px rgba(91, 91, 214, 0.2)',
    },
    Card: {
      borderRadiusLG: 16,
      bodyPadding: 22,
      headerFontSize: 15,
      headerFontSizeSM: 14,
    },
    Drawer: {
      colorBgElevated: '#1c1d25',
    },
    Dropdown: {
      borderRadiusLG: 12,
      controlPaddingHorizontal: 12,
    },
    Form: {
      labelColor: '#3f3f46',
      labelFontSize: 13,
      verticalLabelPadding: '0 0 7px',
    },
    Input: {
      activeBorderColor: '#5b5bd6',
      hoverBorderColor: '#8888e8',
      paddingInline: 13,
    },
    Menu: {
      darkItemBg: '#1c1d25',
      darkSubMenuItemBg: '#171820',
      darkItemColor: '#b8b8c3',
      darkItemHoverBg: '#272833',
      darkItemSelectedBg: '#303142',
      darkItemSelectedColor: '#d8d8ff',
      itemBorderRadius: 10,
      itemHeight: 42,
      itemMarginInline: 12,
      itemMarginBlock: 3,
    },
    Modal: {
      borderRadiusLG: 18,
      titleFontSize: 18,
    },
    Pagination: {
      itemActiveBg: '#eeeeff',
      itemBg: 'transparent',
    },
    Select: {
      optionSelectedBg: '#eeeeff',
      optionSelectedColor: '#4747b8',
    },
    Skeleton: {
      gradientFromColor: '#ededf1',
      gradientToColor: '#f8f8fa',
    },
    Table: {
      borderColor: '#e6e6eb',
      headerBg: '#f5f5f7',
      headerColor: '#64646f',
      headerSplitColor: '#e5e5ea',
      rowHoverBg: '#f7f7fb',
      cellPaddingBlock: 13,
      cellPaddingInline: 16,
    },
    Tabs: {
      itemColor: '#71717a',
      itemSelectedColor: '#5b5bd6',
      itemHoverColor: '#5b5bd6',
      titleFontSize: 14,
    },
    Tag: {
      borderRadiusSM: 999,
      defaultBg: '#f1f1f4',
      defaultColor: '#5c5c66',
      // Status badges contain small text, so the success treatment needs to
      // stay readable on dim desktop displays instead of relying on a pale
      // green tint. White on #166534 has a 7.13:1 contrast ratio (WCAG AAA).
      colorSuccess: '#ffffff',
      colorSuccessBg: '#166534',
      colorSuccessBorder: '#166534',
    },
  },
};
